// Things Data - physical objects, apart from paintings. Import images and metadata.
//
// Scoped to the parent `images` directory (rather than `images/Things` directly)
// so the build doesn't depend on a `Things` folder existing yet — it only has to
// exist once the first item's assets are added under it.
const thingsImagesContext = require.context(
  '../assets/images',
  true,
  /\.(png|jpe?g|gif|webp|JPG)$/
);
const thingsMetadataContext = require.context(
  '../assets/images',
  true,
  /metadata\.json$/
);

// Helper function to import all files from a context, scoped to the Things folder
const importAll = (context: __WebpackModuleApi.RequireContext) =>
  context
    .keys()
    .filter((key) => key.startsWith('./Things/'))
    .map((key) => ({
      path: key,
      data: context(key),
    }));

// Load images and metadata
const thingsImages = importAll(thingsImagesContext);
const thingsMetadata = importAll(thingsMetadataContext);

// Combine images and metadata using the id from the metadata.json file
export const ThingsData = thingsMetadata
  .filter((meta) => {
    const folderName = meta.path.split('/')[meta.path.split('/').length - 2]; // Still using folder name to load images
    const imagesForFolder = thingsImages.filter((image) =>
      image.path.includes(folderName)
    );

    // Only include folders with at least one image
    return imagesForFolder.length > 0;
  })
  .map((meta) => {
    const folderName = meta.path.split('/')[meta.path.split('/').length - 2];
    const imagesForFolder = thingsImages.filter((image) =>
      image.path.includes(folderName)
    );

    // Use the mainImage if specified, otherwise fallback to the first image
    const mainImage = meta.data.mainImage
      ? imagesForFolder.find((image) =>
          image.path.includes(meta.data.mainImage)
        )
      : imagesForFolder[0];

    const defaultMetadata = {
      id: folderName, // Use folder name as fallback id
      title: 'Untitled',
      description: 'No description available.',
    };

    // Merge metadata from the metadata.json file and default metadata
    const metadata = {
      ...defaultMetadata,
      ...meta.data,
    };

    return {
      image: mainImage ? mainImage.data : '', // Display the main image or fallback
      images: imagesForFolder.map((img) => img.data), // Include all images
      metadata, // Include the merged metadata
    };
  });
